/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:29
 * @LastEditors: yy
 * @LastEditTime: 2020-02-26 15:33:24
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Feedback.css';
import logo_brand from './brand.png';
import log_mind from './mind.png';
import Link from '../Link'

class Feedback extends React.Component {
  render() {
    return (
      <div className={s.footer}>
        <ul className={s.footMain}>
          <li className={s.footItem}>
            <span className={s.footTit}>DBRank100</span>
            <Link to='/top100' className={s.footA}>总榜</Link>
            <Link to='/industry' className={s.footA}>行业榜</Link>
            <Link to='/platform' className={s.footA}>平台榜</Link>
            <Link to='/geo' className={s.footA}>地理榜</Link>
            
          </li>
          <li className={s.footItem}>
            <span className={s.footTit}>关于DBRank</span>
            <Link to='/algorithm' className={s.footA}>榜单说明</Link>
            <span >
              <Link to='/dashboard?brandName=腾讯' className={s.footA}>DEMO演示</Link>
            </span>
            <span className={s.footA}>
              <Link to='/report' className={s.footA} >研究报告</Link>
            </span>
          </li>
          <li className={s.footItem}>
            <span className={s.footTit}>
              关于我们</span>
            <Link to='/aboutus' className={s.footA}>公司介绍</Link>
            <a href="javascript:;" className={s.textRight}>媒体联系：pr@dbrank.net</a>
            <a href="javascript:;" className={s.textRight}>加入我们：hr@dbrank.net</a>
          </li>
          <li className={s.footItem}>
            <div className={s.QRcode}>
              <i className={s.QRimg}><img src={logo_brand}/></i>
              <span className={s.QRtxt}>数字品牌榜</span>
            </div>
            <div className={s.QRcode}>
              <i className={s.QRimg}><img src={log_mind}/></i>
              <span className={s.QRtxt}>数字智库</span>
            </div>
          </li>
        </ul>
        <span className={s.WIPO}>Copyright © 2017 版权所有 All Rights Reserved 北京数榜信息科技有限公司  |  <a href="http://www.beian.miit.gov.cn" target="_blank" style={{color: '#fff'}}>京ICP备17049259号</a> 
        </span>
      </div>
    )

    // return (   <div className={s.root}>     <div className={s.container}>
    // <a         className={s.link}
    // href="https://gitter.im/kriasoft/react-starter-kit"       >Ask a question</a>
    //       <span className={s.spacer}>|</span>       <a         className={s.link}
    //         href="https://github.com/kriasoft/react-starter-kit/issues/new"
    // >Report an issue</a>     </div>   </div> );
  }
}

export default withStyles(s)(Feedback);



// WEBPACK FOOTER //
// src/components/Feedback/Feedback.js